<template>
  <section v-if="mediaHeroItems?.length" :class="bem()">
    <MediaHero
      :id="block.id"
      :items="mediaHeroItems"
      :aspect-ratio="aspectRatio"
      :row-position="rowPosition"
      :desktop-layout="desktopLayout"
      :mobile-layout="mobileLayout"
    />
  </section>
</template>

<script setup>
const bem = useBEM('MediaHeroSection')

const props = defineProps({
  block: {
    type: Object,
    required: true,
  },
  rowPosition: {
    type: Number,
    default: 0,
  },
})

const { buildInternalLink } = useUrlBuilder()

const aspectRatio = computed(() => {
  return props.block.aspectRatio
})

const desktopLayout = computed(() => {
  switch (props.block.mediaHeroType.type) {
    case 'media_hero_carousel':
      return 'carousel'
    case 'media_hero_static':
      return 'static'
    default:
      return 'static'
  }
})

const mobileLayout = computed(() => {
  if (props.block.mediaHeroType.type === 'media_hero_carousel') {
    return 'carousel'
  } else {
    if (props.block.mediaHeroType.mobileLayout === 'carousel') {
      return 'carousel'
    }

    return 'static'
  }
})

const mediaHeroItems = computed(() => {
  if(props.block.mediaHeroType) {
    return props.block.mediaHeroType.mediaHeroItems.map((mediaHeroItem) => {
    return {
      title: mediaHeroItem.mediaHeroContent?.title,
      subtitle: mediaHeroItem.mediaHeroContent?.subtitle,
      buttons: mediaHeroItem.mediaHeroContent?.mediaHeroContentButtons,
      image: mediaHeroItem.heroImage?.responsiveImage
        ? mediaHeroItem.heroImage
        : null,
      video: mediaHeroItem.heroVideo?.video
        ? mediaHeroItem.heroVideo.video
        : null,
      buttons: mediaHeroItem.mediaHeroContent?.mediaHeroContentButtons
        .map((button) => {
          return {
            text: button.linkText,
            url: buildInternalLink(button.link),
            style: button.style,
            colour: button.colour,
          }
        })
        .filter((a) => a.url),
    }
    })
  } else {
    return []
  }
})
</script>

<style lang="postcss" scoped>
.MediaHeroSection {
  @apply w-full ;
}
</style>
